<!-- In The News Hero Section -->
<div class="annual-hero-bg">
    <section class="annual-hero-section container">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-6 hero-content-col">
                    <h1 class="banner-heading-one">IN THE NEWS</h1>
                    <p class="hero-subtitle">The Latest Press Releases of Kalpita Technologies</p>
                </div>
                <div class="col-lg-6 hero-image-col text-center">
                    <img src="../../../../assets/resources/news-main/in-the-news-bannerimage.png"
                        alt="In The News Illustration" class="hero-image">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- News List Section -->
<div class="news-list-section">
    <div class="container">
        <h2 class="section-title">Featured Articles</h2>

        <div class="row">
            <!-- ---- Great Place To Work---- -->
            <div class="col-md-4 col-sm-12 d-flex align-items-stretch py-2">
                <div class="card news-card" [routerLink]="['/kalpita-press-release/kalpita-technologies-great-place-to-work-certified']">
                    <div class="pb-2">
                        <img src="../../../../assets/resources/news-main/ktpl-great-place-to-work.webp" alt="goodfirms"
                            class="img-fluid pb-2">
                    </div>
                    <div class="card-content">
                        <div class="info-wrapper">
                            <h5>Kalpita Celebrates GPTW 2025</h5>
                            <p>Kalpita Technologies Secures Great Place to Work Certification™ 2025 for the 4th
                                Consecutive Year</p>
                        </div>
                        <div class="arrow-icon-wrapper">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ---- GoodFirms PR Article ---- -->
            <div class="col-md-4 col-sm-12 d-flex align-items-stretch py-2">
                <div class="card news-card" [routerLink]="['/kalpita-press-release/goodfirms']">
                    <div class="pb-2">
                        <img src="../../../../assets/resources/news-main/goodfirms-pr.webp" alt="goodfirms"
                            class="img-fluid pb-2">
                    </div>
                    <div class="card-content">
                        <div class="info-wrapper">
                            <h5>GoodFirms Features Kalpita</h5>
                            <p>Kalpita Technologies Featured on GoodFirms: Driving Innovation & Global Growth</p>
                        </div>
                        <div class="arrow-icon-wrapper">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ----Most Influential Business Leaders---- -->
            <div class="col-md-4 col-sm-12 d-flex align-items-stretch py-2">
                <div class="card news-card" [routerLink]="['/kalpita-press-release/influential-business']">
                    <div class="pb-2">
                        <img src="../../../../assets/resources/news-main/InfluentialBusiness.webp" alt="anniversary"
                            class="img-fluid pb-2">
                    </div>
                    <div class="card-content">
                        <div class="info-wrapper">
                            <h5>Most Influential Business Leaders Shaping the Modern Industry, 2025</h5>
                            <p>A Soulful Architect of Conscious Innovation – Kube G: Building Innovative, AI-enabled
                                Digital Solutions That Transform How Enterprises Operate, Grow, and Compete</p>
                        </div>
                        <div class="arrow-icon-wrapper">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ----Pioneering AI at Kalpita---- -->
            <div class="col-md-4 col-sm-12 d-flex align-items-stretch py-2">
                <div class="card news-card" [routerLink]="['/kalpita-press-release/pioneering-ai']">
                    <div class="pb-2">
                        <img src="../../../../assets/resources/news-main/PioneeringAIatKalpita.webp" alt="anniversary"
                            class="img-fluid pb-2">
                    </div>
                    <div class="card-content">
                        <div class="info-wrapper">
                            <h5>Pioneering AI at Kalpita</h5>
                            <p>Kalpita Technologies Leads the Charge in AI-Powered Software with RAG, NLP, and Advanced
                                Predictive Analytics</p>
                        </div>
                        <div class="arrow-icon-wrapper">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ----6th Anniversary---- -->
            <div class="col-md-4 col-sm-12 d-flex align-items-stretch py-2">
                <div class="card news-card" (click)="nav('/kalpita-press-release/kalpita-sixth-anniversary')">
                    <div class="pb-2">
                        <img src="../../../../assets/resources/news-main/anniversary-news.webp" alt="anniversary"
                            class="img-fluid pb-2">
                    </div>
                    <div class="card-content">
                        <div class="info-wrapper">
                            <h5>Kalpita 6th Anniversary Celebration</h5>
                            <p>Kalpita Technologies Celebrates 6 Years of Innovation with an Exciting Anniversary
                                Extravaganza (Explore 40 Articles)</p>
                        </div>
                        <div class="arrow-icon-wrapper">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ----About Kalpita---- -->
            <div class="col-md-4 col-sm-12 d-flex align-items-stretch py-2">
                <div class="card news-card" [routerLink]="['/kalpita-press-release/about-kalpita']">
                    <div class="pb-2">
                        <img src="../../../../assets/resources/news-main/about-kalpita.webp" alt="about-kalpita"
                            class="img-fluid pb-2">
                    </div>
                    <div class="card-content">
                        <div class="info-wrapper">
                            <h5>About Kalpita Technologies</h5>
                            <p>Driving India's Digital Future: Kalpita Technologies Leads Innovation With Client-Centric
                                Solutions</p>
                        </div>
                        <div class="arrow-icon-wrapper">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ----About CEO---- -->
            <div class="col-md-4 col-sm-12 d-flex align-items-stretch py-2">
                <div class="card news-card" [routerLink]="['/kalpita-press-release/about-ceo']">
                    <div class="pb-2">
                        <img src="../../../../assets/resources/news-main/ceo-kalpita.webp" alt="ceo"
                            class="img-fluid pb-2">
                    </div>
                    <div class="card-content">
                        <div class="info-wrapper">
                            <h5>About CEO</h5>
                            <p>Empowering Digital Transformation: In a Conversation with Kube G, Co-founder & CEO,
                                Kalpita Technologies</p>
                        </div>
                        <div class="arrow-icon-wrapper">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>